export default __webpack_public_path__ + "static/media/renbtc.9ddef72eed7cf8eb446074a863ab7513.png";